<template>
  <v-container class="grey lighten-5">
    <v-row>
      <v-col cols="12">
        <div class="text-h5">{{ tituloPagina }}</div>
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="userList"
          sort-by="nome"
          :search="search"
          :custom-filter="filterOnlyCapsText"
          :loading="isLoading"
          loading-text="Carregando usuários..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-col cols="5" class="pa-0">
                <v-text-field
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>

              <v-spacer></v-spacer>

              <v-dialog v-model="dialog"  fullscreen max-width="500px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="hidden-sm-and-down"
                    dark
                    color="blue"
                    right
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  >
                    novo
                  </v-btn>

                  <v-btn
                    class="hidden-md-and-up"
                    small
                    dark
                    fab
                    color="blue"
                    right
                    top
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-toolbar dark
                    color="indigo darken-3" >
                    <v-btn icon dark @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ tituloModal }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn dark text
                        @click="save"  >
                        salvar
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-card-text>
                    <v-divider></v-divider>

                    <v-container>
                      <v-row>
                        <v-col cols="auto">
                          <v-select
                            :items="profileList"
                            v-model="editedItem.perfil"
                            item-text="nome"
                            item-value="id"
                            label="Perfil"
                            return-object
                            hide-details
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>

                        <v-col cols="12" md="8">
                          <v-text-field
                            v-model="editedItem.nome"
                            label="Nome"
                            hide-details
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-select
                            :items="itStatus"
                            v-model="editedItem.status"
                            label="Status"
                            hide-details
                          ></v-select>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.celular"
                            v-mask="['(##) #####-####']"
                            label="Celular"
                            hide-details
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.email"
                            label="E-mail"
                            hide-details
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.cpf"
                            v-mask="['###.###.###-##']"
                            label="CPF"
                            hide-details
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-text-field
                            type="password"
                            :disabled='isEditingUser'
                            v-model="editedItem.senha"
                            label="senha"
                            value="password"
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row> 
                      <v-row class="mb-7">
                      </v-row>
                      <v-row v-if="editedItem.perfil.nome === 'Usuário'">
                        <v-col cols="12">
                          <div class="text-h6">Assinaturas</div>
                          <v-divider></v-divider>
                        </v-col>
                        <v-col>
                        <v-data-table
                          :headers="headersAssinatura"
                          :items="editedItem.assinaturasList" 
                        >
                          <template v-slot:top>
                            <v-toolbar flat color="white">
                              <v-spacer></v-spacer>
                              <v-dialog v-model="signatureDialog" max-width="500px">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    class="hidden-sm-and-down"
                                    dark
                                    color="blue"
                                    right
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    nova assinatura
                                  </v-btn>

                                  <v-btn
                                    class="hidden-md-and-up"
                                    small
                                    dark
                                    fab
                                    color="blue"
                                    right
                                    top
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                                </template>

                                <v-card>
                                  <v-card-title>
                                    <span class="headline">Cadastro de assinatura</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-divider></v-divider>
                                  <v-form
                                    ref="form"
                                    lazy-validation
                                  >
                                    <v-container>
                                      <v-row>
                                        <v-col cols="6" sm="3" md="6">
                                          <v-select required
                                            :items="planList"
                                            v-model="assinatura.plano"
                                            item-text="nome"
                                            label="Plano"
                                            hide-details
                                            return-object 
                                          ></v-select>
                                        </v-col>
                                        <v-col cols="6" sm="6" md="4">
                                          <v-select required
                                            :items="itStatus"
                                            v-model="assinatura.status"
                                            label="Status"
                                            hide-details
                                          ></v-select>
                                        </v-col>
                                        <v-col cols="6" sm="3" md="6">
                                          <v-text-field
                                            v-model="assinatura.observacao"
                                            label="Observação"
                                            hide-details
                                          ></v-text-field>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-form>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>

                                    <v-btn color="blue darken-1" text @click="closeAssinatura"
                                      >Cancelar</v-btn
                                    >
                                    <v-btn color="blue darken-1" text @click="salvarAssinatura"
                                      >Salvar</v-btn
                                    >
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-toolbar>
                          </template>
                          <template v-slot:[`item.acao`]="{ item }">
                            <v-icon small class="mr-2" @click="editAssinatura(item)"
                              >mdi-pencil</v-icon >
                            <v-icon small @click="deleteAssinatura(item)">mdi-delete</v-icon>
                          </template>
                          
                        </v-data-table>
                        </v-col>
                        
                      </v-row>
                    </v-container>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:[`item.acao`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"
              >mdi-pencil</v-icon >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Headers from '../../components/jsonsHelper/headers.json';
  import Usuario from '../../models/usuario'
  import Assinatura from '../../models/assinatura'
  import { mapActions, mapState } from 'vuex';
  import { parseDateForUser} from '../../utils/date'

  export default {
    data: () => ({
      tituloPagina: '',
      headers: [],
      headersAssinatura: '',
      search: '',
      dialog: false,
      signatureDialog: false,
      itStatus: ['Ativo', 'Inativo'],
      itPlan: '',
      itPayment: ['Espécie', 'Transferência', 'Boleto', 'Cartão', 'Outros'],
      editedIndex: -1,
      assinaturaIndex: -1,
      editedItem: new Usuario(),
      defaultItem: new Usuario(),
      assinatura: new Assinatura(),
      isEditingUser: false
    }),

    computed: {
      ...mapState('user', ['userList','isLoading']),
      ...mapState('base', ['planList']),
      ...mapState('profile', ['profileList']),
      ...mapState('plan', ['planList']),
      tituloModal() {
        return this.editedIndex === -1 ? 'Novo Usuário' : 'Editar Usuário';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      ...mapActions('user', [ 'getUserList', 'deleteUser',
        'createNewUser', 'changeUserData', 'getUserById']),
      ...mapActions('plan', ['getPlanList']),
      ...mapActions('profile', ['getProfileList']),
      parseDateForUser,
      async initialize() {
            await this.getUserList();
            await this.getProfileList();
            await this.getPlanList();
            this.headers = Headers.usuarioHeaders;
            this.headersAssinatura = Headers.assinaturaHeaders;
            this.tituloPagina = 'Cadastro de Usuários';
      },

      filterOnlyCapsText(value, search) {
        search = search.toString().toLocaleUpperCase();
        return (
          value != null &&
          search != null &&
          typeof value === 'string' &&
          value
            .toString()
            .toLocaleUpperCase()
            .indexOf(search) !== -1
        );
      },

     async editItem(item) {
        this.editedIndex = this.userList.indexOf(item);
        this.editedItem = await this.getUserById(item.idUsuario)
        this.dialog = true;
        this.isEditingUser = true;
      },


      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
        this.isEditingUser = false;
      },
      closeAssinatura () {
        this.signatureDialog = false
          this.$nextTick(() => {
          this.assinatura = Object.assign({}, new Assinatura());
          this.assinaturaIndex = -1;
        });

      },

      async save() {
        this.editedItem.assinaturasList = this.editedItem.assinaturasList.map((assinatura)=>{
          let {dataAssinatura, dataVencimento} = assinatura;
          assinatura.dataAssinatura = formatDateToArray(dataAssinatura)
          assinatura.dataVencimento = formatDateToArray(dataVencimento)
          assinatura.formaPagamento = 'Outros'
          return assinatura
        })
        const resp = this.isEditingUser
          ? await this.changeUserData(this.editedItem)
          : await this.createNewUser(this.editedItem);
        if(resp === 200){
          this.close();
          this.initialize();
        }else{
          this.close();
        }

        function formatDateToArray(stringDate){
          let rawDate = undefined
          if (stringDate) rawDate = stringDate.split('/').map(v=> Number(v))
          if(rawDate && rawDate.length){
            const [day, month, year] = rawDate;
            return [year, month,day]
          }
        }
        
      },
      salvarAssinatura() {
        if(this.$refs.form.validate()){
          if (this.assinaturaIndex > -1) {
            Object.assign(this.editedItem.assinaturasList[this.assinaturaIndex], this.assinatura)
          } else {
            
            this.editedItem.assinaturasList.push(this.assinatura)
          }
          this.closeAssinatura()
        }
      },
      async editAssinatura(item) {
        this.assinaturaIndex = this.editedItem.assinaturasList.indexOf(item);
        this.assinatura =  Object.assign({}, item)
        this.signatureDialog = true;
      },

      deleteAssinatura(item) {
        const index = this.editedItem.assinaturasList.indexOf(item)
        confirm('Tem certeza que deseja excluir este registro definitivamente? (Esta ação não poderá ser desfeita)') && this.editedItem.assinaturasList.splice(index, 1)
      },
    },
  };
</script>
